"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var icons_1 = require("../../icons");
var Carousel = function (props) {
    var _a = __read(react_1.useState(0), 2), itemIndex = _a[0], setItemIndex = _a[1];
    var carouselRef = react_1.useRef(null);
    var slidesAmount = react_1.Children.toArray(props.children).length;
    var onPaginationChange = react_1.useCallback(function (page) {
        var _a;
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.goTo(page - 1);
    }, [carouselRef.current]);
    var onPrev = react_1.useCallback(function () {
        var _a;
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.prev();
    }, [carouselRef.current]);
    var onNext = react_1.useCallback(function () {
        var _a;
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.next();
    }, [carouselRef.current]);
    return (react_1.default.createElement("div", { className: "carouselWrapper" },
        react_1.default.createElement(antd_1.Button, { className: "leftArrowButton", type: "text", onClick: onPrev, style: { visibility: itemIndex === 0 ? "hidden" : "visible" } },
            react_1.default.createElement(icons_1.LeftOutlined, null)),
        react_1.default.createElement(antd_1.Carousel, { dots: false, infinite: false, ref: carouselRef, beforeChange: function (_currentSlide, nextSlide) {
                setItemIndex(nextSlide);
            } }, props.children),
        react_1.default.createElement(antd_1.Button, { className: "rightArrowButton", type: "text", onClick: onNext, style: { visibility: itemIndex + 1 === slidesAmount ? "hidden" : "visible" } },
            react_1.default.createElement(icons_1.RightOutlined, null)),
        react_1.default.createElement(antd_1.Pagination, { simple: true, total: slidesAmount, pageSize: 1, onChange: onPaginationChange, current: itemIndex + 1, disabled: slidesAmount <= 1 })));
};
exports.default = Carousel;
//# sourceMappingURL=index.js.map